module.exports = __webpack_public_path__ + "static/media/wing-logo.22d170ac.svg";